<script setup lang="ts">
import getDepartmentAllParams from "@/types/responses/getDepartmentAllParams"
import getPagenateDepartment from  "@/types/responses/getPagenateDepartment"
import getOperationOffice from "@/types/responses/getOperationOffice"
import getDepartmentResponse from "@/types/responses/getDepartment"
import { Ref, ref, onMounted, computed } from "vue"
import Api from "@/services/api/ApiServiceFabrick"
import i18n from "@/lang/i18n"

const emit = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: getDepartmentResponse | getDepartmentAllParams | null
  disabled: boolean
  exceptionId?: number
  operationOffice: getOperationOffice | null
  departmentId?: number
  isDepartment: boolean
  isChildDepartment: boolean
  errorMessages?: string[];
}>()

type queryParamsType = {
  parent_id: string
}

const departments: Ref<(getDepartmentResponse | getDepartmentAllParams)[]> = ref([])

onMounted( async () => {
  await new Promise((resolve) => {
    resolve(getDepartments())
  })
  if (props.departmentId || props.isDepartment) setDepartment()
})

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

async function getDepartments() {
  if (props.isChildDepartment) {
    await Api().getDepartments(undefined).then((data: getPagenateDepartment) => {
      departments.value = data.data
    })
  } else {
    const queryParams: queryParamsType = {parent_id: 'null'}
    await Api().autoCompleteDepartments(queryParams).then((data: getDepartmentResponse[]) => {
      departments.value = data
    })
  }
}

const filteredDepartments = computed(() => {
  let filteredItems: (getDepartmentResponse | getDepartmentAllParams)[] = departments.value
  if (props.operationOffice) {
    filteredItems = filteredItems.filter((item: getDepartmentResponse | getDepartmentAllParams) => {
      if (props.isChildDepartment) {
        return item?.operation_office_id === props.operationOffice?.id
      } else {
        return item.operationOfficeId === props.operationOffice?.id
      }
    })
  }

  if (props.exceptionId) {
    filteredItems = filteredItems.filter((item) => {
      return item.id != props.exceptionId
    })
  }
  isIncludedCandidates(filteredItems)

  return filteredItems
})

function setDepartment() {
  let department = departments.value.find((item) => item.id === props.departmentId)
  if (props.isDepartment && !props.exceptionId) department = departments.value[0]
  if (props.isChildDepartment) department = departments.value[0]?.parent_department
  if (department) modelValue.value = department
}

function isIncludedCandidates(filteredItems: (getDepartmentResponse | getDepartmentAllParams)[]) {
  const isLength = filteredItems.filter((item: getDepartmentResponse | getDepartmentAllParams) => {
    item.id == props.departmentId
  })?.length
  if (!isLength) modelValue.value = null
}
</script>
<template>
  <v-autocomplete
    :label="i18n.global.t('pages.common.autocomplete.department')"
    v-model="modelValue"
    :items="filteredDepartments"
    item-title="name"
    item-value="name"
    v-bind="{ 'return-object': true }"
    :disabled="props.disabled"
    :readonly="props.isChildDepartment"
    :clearable="!props.isChildDepartment"
    :error-messages="props.errorMessages"
  />
</template>
